// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"17e6aec1ae29e435","4656":"274168c587463789","6918":"15040bb3a4834f6f"}[chunkId] + ".css";
};